import React, {useEffect, useState} from "react";
import {Alert, Backdrop, Button, CircularProgress, Container, Grid, Pagination, Paper, styled} from "@mui/material";
import {Link, useLocation} from "react-router-dom";
import {ApiUrl, PortalUrl} from "../utils/portal-urls";
import AddIcon from "@mui/icons-material/Add";
import {useDispatch, useSelector} from "react-redux";
import ExternalSourceBreadcrumbs from "../ExternalSourceManagement/ExternalSourceBreadcrumbs";
import {addTaxonomyBatch} from "../features/taxonomyBatchSlice";
import NuccSpecialtyValueSetBatchProcessBar from "./NuccSpecialtyValueSetBatchProcessBar";
import {getActiveBatchProgress} from "../ExternalSourceManagement/ExternalSourceBatchProcess";
import NuccSpecialtyValueSetLogsTable from "./NuccSpecialtyValueSetLogsTable";
import {getQueryParams, handleHttpResponse} from "../utils/http-helpers";
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import ShowSnackbar from "../utils/ShowSnackbar";
import {batchCurrentStatus} from "../ExternalSourceManagement/ExternalSourceManagementHome";
import {getAllBatches} from "../features/allBatchesSlice";
import ExternalSourceBatchProgressBar from "../ExternalSourceManagement/ExternalSourceBatchProgressBar";

const StyledContainer = styled(Container)(({theme}) => ({
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),

}))
const StyledDiv = styled('div')({
    display: "flex",
    float: "right",
})
const StyledPaper = styled(Paper)(({theme}) => ({
    padding: theme.spacing(2),
    overflow: 'auto',
    boxShadow: '0 7px 20px #cccccc',
    minHeight: 300,
    borderRadius: '15px'
}))

export default function NuccSpecialtyValueSetPageHome(props) {

    const getParameters = getQueryParams();

    const location = useLocation();
    const path = location.pathname;
    const dispatch = useDispatch();
    const {taxonomyBatchId, taxonomyStatus} = useSelector(state => state.taxonomyBatch);
    const {nuccBatches, batchRefresh} = useSelector(state => state.allBatches);

    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(new Date().getTime());
    const [nuccPageResult, setNuccPageResult] = useState(null);
    const [snackbarMsg, setSnackbarMsg] = useState({open: false, msg: '', msgLv: ''});
    const [page, setPage] = useState(getParameters.page ? parseInt(getParameters.page) : 0);
    const [query, setQuery] = useState("");
    const [queryCount, setQueryCount] = useState(0);
    const [currentViewingQuery, setCurrentViewingQuery] = useState(null);

    useEffect(() => {
        console.log("page changed or refresh, useEffect fetch: ", query, page);
        if (query !== currentViewingQuery && queryCount > 0 && page > 0) {
            setPage(0);
        } else {
            fetchNuccLogsPage("NUCCSpecialty", query, page);
        }
        getActiveBatchProgress("Taxonomy", setLoading, setSnackbarMsg)
            .then(res => {
                if (res) {
                    dispatch(addTaxonomyBatch(res));
                }
            })
        dispatch(getAllBatches());
    }, [refresh, query, page, batchRefresh])

    // useEffect(() => {
    //     if (taxonomyStatus === 'Cancelled') {
    //     }
    //
    // }, [taxonomyStatus])

    const onRefresh = () => {
        setRefresh(new Date().getTime());
    }

    const fetchNuccLogsPage = (source, query, page) => {
        setLoading(true);
        const url = ApiUrl.ExternalSource.getExternalSourceLogs.getPath(source, query, page);
        console.log("Getting NUCC Specialty logs from: " + url);

        fetch(url)
            .then(handleHttpResponse)
            .catch(err => {
                setLoading(false);
                if (err) {
                    console.error(err);
                    setSnackbarMsg({open: true, msg: 'Failed to get NUCCSpecialty Logs', msgLv: 'error'});
                }
            })
            .then(res => {
                setLoading(false);
                if (res) {
                    setNuccPageResult(res);
                    setCurrentViewingQuery(query);
                }
            })
    }


    return (
        <StyledContainer maxWidth='xl'>
            <ExternalSourceBreadcrumbs path={path}/>
            <h3 className="title">
                Specialties Value Sets Management
                <StyledDiv>
                    <Button variant="outlined" component={Link}
                            to={PortalUrl.ExternalSource.NUCCSpecialty.pattern_new_task} endIcon={<AddIcon/>}>New
                        Import Task</Button>
                    <Button variant="outlined" onClick={onRefresh} endIcon={<RefreshRoundedIcon/>}>Refresh</Button>
                </StyledDiv>
            </h3>

            <Grid container spacing={3}>
                <Grid item xs={12} md={12} lg={12}>
                    <h4>Specialties Value Sets Database</h4>
                    <StyledPaper>
                        {nuccPageResult?.content && nuccPageResult.content.length > 0 &&
                            <div>
                                <NuccSpecialtyValueSetLogsTable nuccLogs={nuccPageResult.content}/>
                                <br/>
                                {nuccPageResult.totalPages >= 1 &&
                                    <Pagination page={page + 1} count={nuccPageResult.totalPages} variant="outlined"
                                                color="primary" onChange={(e, newPage) => setPage(newPage - 1)}/>}
                            </div>
                        }
                    </StyledPaper>

                </Grid>
            </Grid>
            <Grid item xs={12} md={12} lg={12} sx={{mt: '25px'}}>
                <h4>Current Specialties Value Sets Progress Information</h4>
                {/*<StyledPaper sx={{minHeight: '200px'}}>*/}
                {/*    {taxonomyStatus && <Alert severity={batchCurrentStatus[taxonomyStatus].getStatus} icon={false}>{batchCurrentStatus[taxonomyStatus].getMsg("NUCC Specialty Value Set")}</Alert> }*/}
                {/*    <br/>*/}
                {/*    { taxonomyBatchId && taxonomyStatus !== 'Completed' && taxonomyStatus !== 'Cancelled' && taxonomyStatus !== 'Failed' &&*/}
                {/*        <NuccSpecialtyValueSetBatchProcessBar /> }*/}
                {/*</StyledPaper>*/}

                {nuccBatches?.length > 0 ?
                    nuccBatches.map( b => (
                        <StyledPaper sx={{minHeight: '200px'}} key={b.id}>
                            {b.status && <Alert severity={batchCurrentStatus[b.status].getStatus}
                                                      icon={false}>{batchCurrentStatus[b.status].getMsg("NUCC Specialty Value Set")}</Alert>}
                            <br/>
                            {b.id && b.status !== 'Completed' && b.status !== 'Cancelled' && b.status !== 'Failed' &&
                                // <NuccSpecialtyValueSetBatchProcessBar batch={b}/>}
                            <ExternalSourceBatchProgressBar batch={b}/>}
                        </StyledPaper>
                    )) :
                    <StyledPaper sx={{minHeight: '200px'}}>
                        <Alert severity='info' icon={false}>No Active Process</Alert>
                    </StyledPaper>
                }

            </Grid>
            <ShowSnackbar open={snackbarMsg.open} close={(c) => setSnackbarMsg(c)} msg={snackbarMsg}/>
            <Backdrop sx={{zIndex: theme => theme.zIndex.drawer + 1, color: "#fff"}} open={loading}>
                <CircularProgress color={"inherit"}/>
            </Backdrop>
        </StyledContainer>
    )
}